import { BehaviorSubject } from "rxjs";
import { Service } from "../../../symphony";

@Service()
export class AINavbarStore {
  public navbarVisible$ = new BehaviorSubject<boolean>(true);
}